import React from "react"
import PropTypes from "prop-types"
import HardDeleteRequests from './HardDeleteRequests'
import SearchUsers from './SearchUsers'

class AdminDash extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      userCount: 0,
      citiesCount: [],
      hardEraseRequests: []
    }
    this.getUserData = this.getUserData.bind(this)
    this.showCities = this.showCities.bind(this)
  }

  componentDidMount() {
    this.getUserData()
  }



  getUserData() {
    $.ajax({
      url: `../get_admin_data_active_users`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          userCount: JSON.parse(data.data.user_count),
          citiesCount: JSON.parse(data.data.cities_count),
          hardEraseRequests: JSON.parse(data.data.hard_erase_requests)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  showCities() {
    return this.state.citiesCount.map((city, i) => {
      const color = city.c > 1000 ? '#C5B7FF' : city.c > 100 ? 'rgba(255, 82, 161, 0.5)' : '#FCD2D2'
      return(
        <div key={i} style={{display: 'flex', alignItems: 'center', marginTop: 5}}>

          <p style={{backgroundColor: color, width: 65, padding: 3, borderRadius: 10, textAlign: 'center', marginRight: 20}}>{city.c}</p>
          <p>{city.location}</p>
        </div>
      )
    })
  }

  render() {
    return(

      <div className="admin_dashboard">
        <div>
          <div className="admin_total_count">
            <h1>{this.state.userCount}</h1>
            <p>Total active accounts</p>
          </div>
          <SearchUsers />
          <HardDeleteRequests hardEraseRequests={this.state.hardEraseRequests}/>
        </div>
        <div className="admin_section_outline">
          <h5>Top Cities</h5>
          {this.showCities()}
        </div>
      </div>
    )
  }
}

//missingImg={this.props.missingImg}

export default AdminDash;
